import { ALLOWED_SOURCE_DOMAINS } from "@/constants/allowedSourceDomains";

export function isValidHttpUrl(value: string): boolean {
  if (!value) return true;
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function getHostname(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export function normalizeUrl(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return "";

  // Dot excluded from scheme chars so `example.com:8080` isn't parsed as a
  // scheme; a real dangerous scheme like `mailto:` or `javascript:` still matches.
  const schemeMatch = trimmed.match(/^([a-zA-Z][a-zA-Z0-9+-]*):/);
  if (schemeMatch) {
    const scheme = schemeMatch[1].toLowerCase();
    if (scheme !== "http" && scheme !== "https") return null;
  }
  const candidate = schemeMatch ? trimmed : `https://${trimmed}`;

  try {
    const url = new URL(candidate);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    if (!url.hostname) return null;
    return candidate;
  } catch {
    return null;
  }
}

export function isDomainAllowed(urlOrHostname: string): boolean {
  const hostname = getHostname(urlOrHostname).toLowerCase();
  if (!hostname) return false;
  return ALLOWED_SOURCE_DOMAINS.some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
  );
}
